module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_20.671c5f2b.png";